/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiAlertType;
(function (ApiAlertType) {
    ApiAlertType["ALERT"] = "ALERT_TYPE_ALERT";
    ApiAlertType["DIGEST"] = "ALERT_TYPE_DIGEST";
})(ApiAlertType || (ApiAlertType = {}));
export function ApiAlertTypeFromJSON(json) {
    return ApiAlertTypeFromJSONTyped(json, false);
}
export function ApiAlertTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiAlertTypeToJSON(value) {
    return value;
}
